export const restrictOperation = (bvids: string[], bvid: string) => {
  return bvids?.includes(bvid)
}
